<template>
  <section class="app-main" :style="{ height: clientHeight + 'px' }">
    <el-header class="header">
      <main-header></main-header>
    </el-header>
    <main-tab></main-tab>
    <transition name="fade" mode="out-in">
      <keep-alive>
        <router-view class="page"></router-view>
      </keep-alive>
    </transition>
  </section>
</template>

<script>
  import MainHeader from './header'
  import MainTab from './tab'

  export default {
    name: 'main-content',
    data() {
      return {
        clientHeight: 0
      }
    },
    components: { MainHeader, MainTab },
    created() {
      this.getClientHeight()
    },
    methods: {
      getClientHeight() {
        this.clientHeight = document.documentElement.clientHeight
      }
    }
  }
</script>

<style lang="stylus">
  .app-main
    min-height 100%
    width 100%
    background-color #eaeff3
    overflow hidden
    .page
      overflow-y auto
      background-color #EAEFF3
      padding 30px
    .page::-webkit-scrollbar
      width 10px
      height 1px
    .page::-webkit-scrollbar-thumb
      border-radius 10px
      box-shadow inset 0 0 5px rgba(0, 0, 0, 0.2)
      background #DDDEE0
</style>
